<p-dialog
  [(visible)]="displayTaskDetailModal"
  (onHide)="closeTaskDetailModal()"
  class="summary-popup"
  [style]="{
    width: '80%',
    height: '90%',
    maxHeight: '100%',
    overflow: 'hidden',
  }"
  appendTo="body"
  [draggable]="false"
  [resizable]="false">
  <ng-template #header class="edit-header">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center gap-2">
        <h2 class="m-0">Edit Task</h2>
        <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
      </div>

      <div class="d-flex gap-2" [formGroup]="form">
        <div class="d-flex align-items-center gap-2" formGroupName="parentTask">
          <p class="mb-0">Dateless</p>
          <div>
            <p-toggleswitch
              (onChange)="onDateLessSwitchChangeEvent($event)"
              formControlName="isDateLess" />
          </div>
        </div>

        <div class="d-flex align-items-center gap-2" formGroupName="parentTask">
          <p class="mb-0">Notify Me</p>
          <div><p-toggleswitch formControlName="notification" /></div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="editsummary-popup">
    <div class="col-12">
      <div class="col-12">
        <div class="row gray-bg-rounded bdr-rounded" [formGroup]="form">
          <div class="col-lg-8">
            <div>
              <div class="row g-3">
                <div class="col-md-6" formGroupName="parentTask">
                  <label class="w-100">Task *</label>
                  <input pInputText class="w-100" formControlName="title" />
                  <span class="text-danger" *ngIf="formErrors['title']">{{
                    formErrors["title"]
                  }}</span>
                </div>

                <div class="col-md-3" formGroupName="subTask">
                  <label class="w-100">Due Date *</label>
                  <p-datepicker
                    formControlName="dueDate"
                    dateFormat="mm/dd/yy"
                    class="w-100">
                  </p-datepicker>
                  <span class="text-danger" *ngIf="formErrors['dueDate']">{{
                    formErrors["dueDate"]
                  }}</span>
                </div>

                <div class="col-md-3">
                  <label class="w-100">Status</label>
                  <p-select
                    [options]="taskStatusList"
                    [(ngModel)]="selectedTaskStatus"
                    optionLabel="name"
                    optionValue="name"
                    optionDisabled="disabled"
                    class="w-100">
                  </p-select>
                </div>
              </div>

              <div class="row g-3 mt-2" formGroupName="subTask">
                <div class="col-md-6">
                  <label class="w-100">Nick Name</label>
                  <input pInputText class="w-100" formControlName="nickName" />
                  <span class="text-danger" *ngIf="formErrors['nickName']">{{
                    formErrors["nickName"]
                  }}</span>
                </div>

                <div class="col-md-3">
                  <label class="w-100">ESD</label>
                  <p-datepicker
                    class="w-100"
                    formControlName="esd"
                    dateFormat="mm/dd/yy"></p-datepicker>
                  <span class="text-danger" *ngIf="formErrors['esd']">{{
                    formErrors["esd"]
                  }}</span>
                </div>

                <div class="col-md-3">
                  <label class="w-100">PO#</label>
                  <input
                    pInputText
                    class="w-100"
                    formControlName="purchaseOrderNumber" />
                  <span
                    class="text-danger"
                    *ngIf="formErrors['purchaseOrderNumber']"
                    >{{ formErrors["purchaseOrderNumber"] }}</span
                  >
                </div>
              </div>

              <div class="row g-3 mt-2" formGroupName="subTask">
                <div class="col-md-6">
                  <label class="w-100">Supplier</label>
                  <input pInputText class="w-100" formControlName="supplier" />
                  <span class="text-danger" *ngIf="formErrors['supplier']">{{
                    formErrors["supplier"]
                  }}</span>
                </div>

                <div class="col-md-3">
                  <label class="w-100">IHD</label>
                  <p-datepicker
                    class="w-100"
                    formControlName="ihd"
                    dateFormat="mm/dd/yy"></p-datepicker>
                  <span class="text-danger" *ngIf="formErrors['ihd']">{{
                    formErrors["ihd"]
                  }}</span>
                </div>

                <div class="col-md-3">
                  <label class="w-100">Remind Me</label>
                  <p-datepicker
                    [showTime]="true"
                    hourFormat="12"
                    class="w-100"
                    formControlName="remindMe"
                    dateFormat="mm/dd/yy"></p-datepicker>
                </div>
              </div>

              <div class="mt-4" formGroupName="parentTask">
                <p-editor
                  formControlName="description"
                  [style]="{ height: '250px' }">
                </p-editor>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div formGroupName="subTask">
              <div class="mb-3 pb-1" *ngIf="showOwner">
                <label>Assigned To</label>
                <p-select
                  [options]="ownerList"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  [showClear]="true"
                  formControlName="assignedTo"
                  class="w-100">
                </p-select>
              </div>

              <div class="mb-4">
                <label>Priority *</label>
                <div class="priority-select-wrapper">
                  <p-selectButton
                    [options]="priorityLevelFiltered"
                    formControlName="priority"
                    optionLabel="title"
                    optionValue="id">
                    <ng-template #item let-item>
                      <span class="bullet-btn">
                        <i
                          class="pi pi-circle-fill"
                          [style.color]="item.color"></i>
                      </span>
                      {{ item.title }}
                    </ng-template>
                  </p-selectButton>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-6">
                  <label>Client</label>
                  <input
                    pInputText
                    class="w-100"
                    formControlName="client"
                    [disabled]="true" />
                </div>

                <div class="col-6">
                  <label>Project</label>
                  <p-select
                    #projectSelect
                    (onChange)="onProjectChange($event)"
                    (onShow)="onProjectDropdownShow()"
                    [filter]="true"
                    [filterValue]="projectFilterValue"
                    (onFilter)="onProjectFilter($event)"
                    [lazy]="true"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="40"
                    (onLazyLoad)="onProjectLazyLoad($event)"
                    appendTo="body"
                    optionValue="projectWorkflowId"
                    optionLabel="projectLabel"
                    [showClear]="true"
                    (onClear)="onProjectClear()"
                    [options]="projectLists"
                    [loading]="projectLoading"
                    loadingIcon="pi pi-spinner pi-spin"
                    formControlName="project"
                    placeholder="Select Project"
                    class="w-100">
                    <ng-template let-item #item>
                      <span class="project-label">
                        {{ item.projectLabel }}
                      </span>
                    </ng-template>
                    <ng-template #loader>
                      <div
                        class="d-flex align-items-center justify-content-center gap-2 p-2">
                        <i class="pi pi-spinner pi-spin"></i>
                        <span>Loading more projects...</span>
                      </div>
                    </ng-template>
                    <ng-template #footer>
                      <div
                        *ngIf="projectLoading"
                        class="d-flex align-items-center justify-content-center gap-2 p-2 border-top">
                        <i class="pi pi-spinner pi-spin"></i>
                        <span>Loading...</span>
                      </div>
                    </ng-template>
                  </p-select>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-6">
                  <label>Job Name</label>
                  <input
                    pInputText
                    class="w-100"
                    formControlName="jobName"
                    [disabled]="true" />
                </div>

                <div class="col-6">
                  <label>Linked Order</label>
                  <input
                    pInputText
                    class="w-100"
                    formControlName="linkedOrder"
                    [disabled]="true" />
                </div>
              </div>
              <div class="mb-3">
                <label>Buyer Name</label>
                <div class="d-flex gap-2">
                  <input pInputText class="w-100" formControlName="buyerName" />
                  <button pButton type="button" icon="pi pi-plus"></button>
                </div>
              </div>

              <div class="mb-3">
                <label>Select Tags</label>
                <p-multiSelect
                  [options]="tagsList"
                  optionLabel="tagTitle"
                  formControlName="tag"
                  [filter]="false"
                  appendTo="body"
                  class="multiselect-custom"
                  [showHeader]="false"
                  class="w-100 tag-pad">
                  <ng-template let-selectedValues pTemplate="selectedItems">
                    <div
                      class="country-item country-item-value edit-tag-bdr"
                      *ngFor="let option of selectedValues">
                      <div
                        [style.color]="option.tagColor"
                        class="d-flex gap-2 align-items-center">
                        <span class="tag-ico"
                          ><i class="pi pi-circle-fill"></i
                        ></span>
                        <span class="tag-text">{{ option.tagTitle }}</span>
                        <span class="tag-text-cross"
                          ><i class="pi pi-times"></i
                        ></span>
                      </div>
                    </div>
                    <div
                      *ngIf="!selectedValues || selectedValues.length === 0"
                      class="country-placeholder">
                      Select Tags
                    </div>
                  </ng-template>

                  <ng-template let-tag let-i="index" pTemplate="item">
                    <div
                      class="country-item d-flex justify-content-between w-full w-100">
                      <div class="edit-tag-bdr">
                        <div
                          [style.color]="tag.tagColor"
                          class="d-flex gap-2 align-items-center">
                          <span class="tag-ico"
                            ><i class="pi pi-circle-fill"></i
                          ></span>
                          <span class="tag-text">{{ tag.tagTitle }}</span>
                          <span
                            class="tag-text-cross"
                            (click)="deletePTag(tag.tagId)">
                            <i class="pi pi-times"></i>
                          </span>
                        </div>
                      </div>
                      <a
                        href="javascript:;"
                        class="tag-link"
                        *ngIf="tagsList.indexOf(tag) === 0"
                        (click)="
                          showCreateTagDisplay(); $event.stopPropagation()
                        ">
                        Add Tag
                      </a>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>

              <div class="row">
                <div class="col-7" formGroupName="parentTask">
                  <div class="mb-3">
                    <label>Task Type</label>
                    <p-select
                      [options]="taskTypes"
                      optionLabel="title"
                      optionValue="id"
                      formControlName="taskType"
                      class="w-100"
                      [disabled]="true">
                    </p-select>
                  </div>
                </div>
                <div class="col-5">
                  <div class="d-flex justify-content-between mt-4">
                    <button
                      pButton
                      label="Cancel"
                      class="p-button-secondary p-button-sm p-button-outlined"
                      (click)="closeAddTask()"></button>

                    <button
                      pButton
                      label="Update Task"
                      class="p-button-primary"
                      (click)="updateTask()"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row gray-bg-rounded bdr-rounded mt-3">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-8">
                <div>
                  <textarea
                    pInputTextarea
                    rows="3"
                    class="w-100 p-3 border"
                    placeholder="Write a comment..."
                    [(ngModel)]="comment">
                  </textarea>

                  <div class="text-end mt-2">
                    <button
                      pButton
                      label="Comment"
                      (click)="sendMessage()"></button>
                  </div>

                  <div class="mt-2">
                    <h5 class="mb-4">
                      Comments
                      <span class="comment-num">{{ commentList.length }}</span>
                    </h5>

                    <div
                      *ngFor="let c of commentList"
                      class="mb-3 d-flex gap-2">
                      <p-avatar
                        *ngIf="commentUserPictures.get(c.createdByEmail)"
                        [image]="commentUserPictures.get(c.createdByEmail)"
                        shape="circle"
                        size="large"
                        class="comment-avatar"></p-avatar>
                      <p-avatar
                        *ngIf="!commentUserPictures.get(c.createdByEmail)"
                        [label]="getAcronym(c.createdBy) || ''"
                        [style]="{
                          'background-color': getColor(c.createdBy || ''),
                          color: getTextColor(c.createdBy || ''),
                        }"
                        shape="circle"
                        size="large"
                        class="comment-avatar"></p-avatar>
                      <span class="mt-2 comment-section">
                        <span class="d-flex gap-2 align-items-center">
                          <h6 class="mb-0">{{ c.createdBy }}</h6>
                          <small class="text-muted ms-2 comment-date">
                            {{ c.createdDate | date: "short" }}
                          </small>
                        </span>
                        <p class="mb-0" [innerHTML]="c.comment"></p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0">Attachments</h5>
                    <div class="d-flex gap-2">
                      <button
                        pButton
                        label="Attachment"
                        (click)="fileInput.click()"></button>
                      <input
                        #fileInput
                        type="file"
                        style="display: none"
                        (change)="uploadTrackingFile($event)" />
                      <button
                        pButton
                        label="Add Links"
                        (click)="openTaskFileLinkDailog('Add')"></button>
                    </div>
                  </div>

                  <!-- Display links -->
                  <div *ngIf="taskFileLinkList.length > 0" class="mb-3">
                    <h6 class="mb-2">Links</h6>
                    <div
                      *ngFor="let item of taskFileLinkList"
                      class="mb-2 d-flex justify-content-between align-items-center p-2 border rounded">
                      <a
                        [href]="item.fileUrl"
                        target="_blank"
                        class="text-primary text-truncate flex-grow-1">
                        {{ item.fileName }}
                      </a>
                      <div class="d-flex gap-2">
                        <span class="tag-text-cross">
                          <i
                            class="pi pi-pencil"
                            style="cursor: pointer"
                            (click)="editLink(item)"></i>
                        </span>
                        <span class="tag-text-cross">
                          <i
                            class="pi pi-times"
                            style="cursor: pointer"
                            (click)="deleteLink(item)"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Display existing task documents (from API) -->
                  <div
                    *ngIf="
                      taskDetail.documents && taskDetail.documents.length > 0
                    "
                    class="mb-3">
                    <h6 class="mb-2">Task Documents</h6>
                    <div
                      *ngFor="
                        let doc of taskDetail.documents;
                        trackBy: trackByDocument
                      "
                      class="mb-2">
                      <p-tag
                        [value]="doc.name"
                        class="w-100"
                        (click)="downloadFile(doc.url)">
                      </p-tag>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="{{ taskFileLinkModalHeader }}"
  [position]="'center'"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showAddTaskFileLinkModal"
  [style]="{
    width: '360px',
    height: '320px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-4">
      <label class="form-label" for="taskFileLink">File Link</label>
      <input
        pInputText
        type="text"
        class="form-control"
        id="taskFileLink"
        name="taskFileLink"
        [(ngModel)]="taskFileLink" />
    </div>
    <div class="form-group has-float-label mt-2 mb-4">
      <label class="form-label" for="taskLinkName">Link Name</label>
      <input
        pInputText
        type="text"
        class="form-control"
        id="taskLinkName"
        name="taskLinkName"
        [(ngModel)]="taskLinkName" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <div class="row">
        <div class="col">
          <div class="d-flex mb-2 gap-2">
            <p-button label="Cancel" (click)="closeLinkFileLinkDailog()" />

            <p-button
              label="Update"
              (click)="editTaskFileLink()"
              *ngIf="taskFileLinkMode === 'Edit'" />

            <p-button
              label="Save"
              (click)="addTaskFileLink()"
              *ngIf="taskFileLinkMode === 'Add'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Project Change Confirmation Modal -->
<p-dialog
  [(visible)]="showSalesTaskProjectFieldsOverrideModal"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '450px' }"
  (onHide)="closeSalesTaskProjectFieldsOverrideModal()">
  <ng-template #header>
    <div class="flex align-items-center gap-2">
      <span class="font-semibold">Confirm Project Change</span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-3">
    <p>Changing the project will override the following fields:</p>
    <ul class="mt-2">
      <li>Client</li>
      <li>Linked Order</li>
      <li>Job Name</li>
      <li>IHD (Order In Hand Date)</li>
      <li>Buyer Name</li>
    </ul>
    <p>Do you want to continue?</p>
  </div>

  <ng-template #footer>
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        severity="secondary"
        (click)="cancelProjectChange()" />
      <p-button label="Confirm" (click)="confirmProjectChange()" />
    </div>
  </ng-template>
</p-dialog>
